import ApontamentoEntidadeEvent from "@/domain/events/apontamentoEntidade.event";
import {reactive} from "vue";

class SeguroEvents {

    apontamentoEvent = new ApontamentoEntidadeEvent()

    listenerSeguroGravado = reactive({value: {seguroId: ''}})
    listenerSeguroAlterado = reactive({value: {seguroId: ''}})

    emitSeguroGravado(seguroId: string) {
        this.listenerSeguroGravado.value = {seguroId: seguroId}
    }

    emitSeguroAlterado(seguroId: string) {
        this.listenerSeguroAlterado.value = {seguroId: seguroId}
    }


}

export default SeguroEvents;